import { RoommateData } from 'src/features/multi-occupancy/types';
import { Basket, BasketUser } from 'src/store/slices/basket-slice';

import { studentBookingClient } from '../client';

import { BasketServiceEndpoints } from './constants';
import { CreateBasketDto } from './dto/CreateBasket.dto';
import {
    AddUserToBasketSuccessResponse,
    GetBasketSuccessResponse,
    PostAddRoommatesSuccessResponse,
    PostBasketServiceSuccessResponse,
    PostSignAgreementsSuccessResponse,
    SignAgreementsDto,
    UpdateBasketSuccessResponse,
} from './types';
import { UpdateBasketDto } from './dto/UpdateBasket.dto';

export const createBasket = async (basketData: Basket): Promise<Basket> => {
    const { data: response } = await studentBookingClient.post<PostBasketServiceSuccessResponse>(
        BasketServiceEndpoints.PostCreateBasket,
        new CreateBasketDto(basketData)
    );
    return response.data;
};

export const updateBasket = async (
    basketId: string,
    basketData: Partial<Basket>,
    updatedAt: string
): Promise<Basket> => {
    const payload = new UpdateBasketDto(basketData, updatedAt);

    const { data: response } = await studentBookingClient.patch<UpdateBasketSuccessResponse>(
        BasketServiceEndpoints.UpdateBasket.replace('{id}', basketId),
        payload
    );
    return response.data;
};

export const addUserToBasket = async (
    basketId: string,
    userData: BasketUser,
    updatedAt: string
): Promise<Basket> => {
    const { data: response } = await studentBookingClient.post<AddUserToBasketSuccessResponse>(
        BasketServiceEndpoints.PostAddUserToBasket.replace('{id}', basketId),
        { user: userData, updatedAt }
    );
    return response.data;
};

export const getBasket = async (basketId: string): Promise<Basket> => {
    const { data: response } = await studentBookingClient.get<GetBasketSuccessResponse>(
        BasketServiceEndpoints.GetBasket.replace('{id}', basketId)
    );
    return response.data;
};

export const postSignAgreements = async (
    basketId: string,
    agreementsData: SignAgreementsDto,
    updatedAt: string
): Promise<Basket> => {
    const payload = {
        signAgreementsDto: agreementsData,
        updatedAt,
    };

    const { data: response } = await studentBookingClient.post<PostSignAgreementsSuccessResponse>(
        BasketServiceEndpoints.SignAgreements.replace('{id}', basketId),
        payload
    );
    return response.data;
};

export const postAddRoommatesToBasket = async (
    basketId: string,
    roommates: RoommateData[],
    updatedAt: string
) => {
    const payload = {
        room_mates: roommates.map((roommate) => ({
            first_name: roommate.first_name,
            last_name: roommate.last_name,
            email: roommate.email,
        })),
        updatedAt,
    };

    const { data: response } = await studentBookingClient.post<PostAddRoommatesSuccessResponse>(
        BasketServiceEndpoints.PostAddRoommatesToBasket.replace('{id}', basketId),
        payload
    );

    return response.data;
};
